import React, {useCallback, useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import BiographyBookMainData from "../BiographyBookMainData";

/**
 * 아카이브 > 회고록 > 메인 > 슬라이드
 */
const BiographyMainList = ({posts}) => {

    const [mainList, setMainList] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);
    const slidesWrapperRef = useRef(null);
    const slideTimer = useRef(null);
    const [tocsState, setTocsState] = useState({});

    const [autoPlayEnabled, setAutoPlayEnabled] = useState(true);
    const autoPlayTimeout = useRef(null);

    useEffect(() => {
        const fetchedData = BiographyBookMainData;
        if (fetchedData.length > 0) {
            setMainList([fetchedData[fetchedData.length - 1], ...fetchedData.slice(0, -1)]);
        }
    }, []);

    useEffect(() => {
        const mainData = posts.filter(item => mainList.some(list => item.book_id === list.book_id));

        // 각 도서의 book_id마다 목차 존재 여부를 저장하는 객체
        const newTocsState = {};
        mainData.forEach(data => {
            newTocsState[data.book_id] = data.n_tocs > 0;
        });
        setTocsState(newTocsState);

    }, [posts, mainList]);

    // 슬라이드 속도 관련 세팅
    const settings = {
        speed: 800, // 슬라이드 전환 속도 (ms)
        interval: 5000 // 자동 슬라이드 전환 간격 (ms)
    };

    const moveSlide = useCallback((isPrev = false) => {
        if (isAnimating || !slidesWrapperRef.current) return;
        const wrapper = slidesWrapperRef.current;
        const items = wrapper.children;
        const itemWidth = items[0].offsetWidth;
        setIsAnimating(true);

        wrapper.style.transition = `transform ${settings.speed}ms ease-in-out`;
        wrapper.style.transform = `translateX(${isPrev ? itemWidth : -itemWidth}px)`;

        const handleTransitionEnd = () => {
            wrapper.style.transition = "none";
            wrapper.style.transform = "";

            if (!isPrev) {
                // 첫 번째 아이템을 마지막으로 이동
                const firstItem = wrapper.firstElementChild;
                wrapper.appendChild(firstItem);
            } else {
                // 마지막 아이템을 처음으로 이동
                const lastItem = wrapper.lastElementChild;
                wrapper.prepend(lastItem);
            }
            setIsAnimating(false);
        }

        // CSS 애니메이션이 종료되었을 때 발생
        wrapper.addEventListener('transitionend', handleTransitionEnd, {once: true});
    }, [isAnimating, settings.speed]);

    const handleSlideButtonClick = useCallback((isPrev) => {
        // 자동 재생 중지
        setAutoPlayEnabled(false);
        clearInterval(slideTimer.current);

        // 슬라이드 이동
        moveSlide(isPrev);

        // 이전 타임아웃 제거
        clearTimeout(autoPlayTimeout.current);

        // 4초 후 자동 재생 재시작
        autoPlayTimeout.current = setTimeout(() => {
            setAutoPlayEnabled(true);
        }, 2000);
    }, [moveSlide]);

    const autoPlay = useCallback(() => {
        if (autoPlayEnabled) {
            clearInterval(slideTimer.current);
            slideTimer.current = setInterval(() => moveSlide(), 4000);
        }
    }, [autoPlayEnabled]);

    useEffect(() => {
        autoPlay();
    }, [autoPlayTimeout, autoPlay]);

    return (
        <div className="main-list-wrap">
            <div className="slide-control">
                <button
                    type="button"
                    className="slides-btn prev"
                    onClick={() => handleSlideButtonClick(true)}
                >
                    이전
                </button>
                <button
                    type="button"
                    className="slides-btn next"
                    onClick={() => handleSlideButtonClick(false)}
                >
                    다음
                </button>
            </div>
            <div className="main-list">
                <ul className="list-slides"
                    ref={slidesWrapperRef}
                >
                    {mainList.map((list, index) => (
                        <li key={index}>
                            <div className="item">

                                {(tocsState[list.book_id] === false) ?
                                    <div className="imgbox">
                                        <img src={`/images/biography/` + list.image} alt={list.title}/>
                                    </div>
                                    :
                                    <div className="imgbox">
                                        <Link to={`/archive/biography/${list.book_id}`}>
                                            <img src={`/images/biography/` + list.image} alt={list.title}/>
                                        </Link>
                                    </div>
                                }

                                <div className="list-info">
                                    <p className="title">{list.title}</p>
                                    <p>{list.author}</p>
                                    <p>{list.year}</p>
                                    <p>{list.publisher}</p>
                                    {tocsState[list.book_id] &&
                                        <Link
                                            to={`/archive/biography/${list.book_id}`}
                                            className="btn color2">
                                            목차보기
                                        </Link>
                                    }
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default BiographyMainList;
